import _classCallCheck from "/mnt/sdb/frontend/ibus/app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/mnt/sdb/frontend/ibus/app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/mnt/sdb/frontend/ibus/app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/mnt/sdb/frontend/ibus/app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/mnt/sdb/frontend/ibus/app/node_modules/@babel/runtime/helpers/esm/inherits";
import _objectWithoutProperties from "/mnt/sdb/frontend/ibus/app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import * as React from 'react';
import { createStyles, FormHelperText, TextField, withStyles } from '@material-ui/core';
import MaskedInput from 'react-text-mask';
import { checkRequired } from './utils';

var styles = function styles() {
  return createStyles({
    error: {
      marginTop: 4
    }
  });
};

function TextMaskCustom(props) {
  var inputRef = props.inputRef,
      other = _objectWithoutProperties(props, ["inputRef"]);

  return React.createElement(MaskedInput, Object.assign({}, other, {
    mask: props.mask,
    pipe: props.pipe,
    guide: true
  }));
}

var Input =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Input, _React$Component);

  function Input() {
    var _this;

    _classCallCheck(this, Input);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Input).apply(this, arguments));
    _this.state = {
      focus: false
    };

    _this.onFocus = function () {
      _this.setState({
        focus: true
      });
    };

    _this.onBlur = function () {
      _this.setState({
        focus: false
      });
    };

    return _this;
  }

  _createClass(Input, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          handler = _this$props.handler,
          meta = _this$props.meta,
          hasError = _this$props.hasError,
          touched = _this$props.touched,
          status = _this$props.status,
          classes = _this$props.classes,
          value = _this$props.value;
      var focus = this.state.focus;
      var isDisabled = status === 'DISABLED';
      var isRequired = checkRequired(this.props);
      var InputProps = {};

      if (meta.mask) {
        InputProps.inputComponent = TextMaskCustom;
        InputProps.inputProps = {
          mask: meta.mask,
          pipe: meta.pipe
        };
      } else {
        if (meta.maxLength) {
          InputProps.inputProps = {
            maxLength: meta.maxLength
          };
        }
      }

      return React.createElement(React.Fragment, null, React.createElement(TextField, Object.assign({
        id: 'outlined-dense',
        label: meta.label,
        margin: 'dense',
        variant: 'outlined',
        fullWidth: true
      }, handler(), {
        onFocus: this.onFocus,
        onBlur: this.onBlur,
        error: touched && hasError('required'),
        required: isRequired,
        disabled: isDisabled,
        InputProps: InputProps,
        InputLabelProps: {
          shrink: !!value || focus
        }
      })), touched && hasError('required') && React.createElement(FormHelperText, {
        className: classes.error,
        error: true
      }, "\u041F\u043E\u043B\u0435 \u043E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u043E \u0434\u043B\u044F \u0437\u0430\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u044F"));
    }
  }]);

  return Input;
}(React.Component);

export default withStyles(styles, {
  name: 'Input'
})(Input);